import { useMemo } from 'react'
import { Schemas } from '~/api/gen'
import { Divider } from '~/components/elements/Divider'
import { Brand } from './ChipList/Brand'
import { FavoriteBrand } from './ChipList/FavoriteBrand'
import { SimilarItemCoordinate } from './ChipList/SimilarItemCoordinate'
import { Tags } from './ChipList/Tags'
import { ModelInfo } from './ModelInfo'
import { RelationFolders } from './RelationFolders'
import { ShopInfo } from './ShopInfo'

type Props = {
  coordinate: Schemas.coordinate_large_with_member_shop_brands
  coordinateItems: Schemas.coordinate_item_response[]
  coordinateFolders: Schemas.folder_summary[]
  frequentlyUsedBrands?: Schemas.member_large_detail['often_use_coordinate_item_brands']
}

export const CoordinateSubInformation: React.FC<Props> = ({
  coordinate,
  coordinateItems,
  coordinateFolders,
  frequentlyUsedBrands = [],
}) => {
  /**
   * アイテム一覧から同じブランド名を除いたリスト
   */
  const brands = useMemo(() => {
    return coordinateItems.reduce<Schemas.coordinate_item_response[]>(
      (arr, val) => {
        if (
          !arr.some((e) => e.item.brand.name === val.item.brand.name) &&
          val.item.brand.name !== ''
        ) {
          arr.push(val)
        }
        return arr
      },
      []
    )
  }, [coordinateItems])

  return (
    <>
      <div className="px-4 pb-6 xl:p-0 ">
        <div className="grid gap-y-[22px] pt-[18px] xl:gap-y-7 xl:pt-7">
          {brands.length > 0 ? <Brand brands={brands} /> : null}
          {coordinate.tags.length > 0 ? <Tags coordinate={coordinate} /> : null}
          <ModelInfo coordinate={coordinate} />
          {coordinate.member.shop !== null && (
            <ShopInfo shop={coordinate.member.shop} />
          )}
        </div>
        {(frequentlyUsedBrands.length > 0 || coordinateItems.length > 0) && (
          <div className="hidden gap-y-[22px] pt-[22px] xl:grid xl:gap-y-7 xl:pt-8">
            <div className="hidden xl:block xl:pb-[2px]">
              <Divider />
            </div>
            {frequentlyUsedBrands.length > 0 && (
              <FavoriteBrand brands={frequentlyUsedBrands} />
            )}
            {coordinateItems.length > 0 && (
              <SimilarItemCoordinate brands={coordinateItems} />
            )}
          </div>
        )}
      </div>
      {coordinateFolders.length > 0 ? (
        <div className="pb-[6px] xl:hidden">
          <RelationFolders coordinateFolders={coordinateFolders} />
        </div>
      ) : null}
    </>
  )
}
